<template>
    <!--企业门店详情-->
  <div class="store">
        <div class="store-title">用户活跃信息</div>
        <div  class="d-flex flex-wrap flex-padding">
            <div class="d-center-start w-50 mb-3"><left-text leftText="活跃值"/>{{storeInfo.exp}}</div>
            <div class="d-center-start w-50 mb-3"></div>
            <div class="d-center-start w-50 mb-3" v-for="item in activityArr" :key="item.cn">
                <left-text :leftText="item.cn"/>{{item.value}}
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'UserActivity',
  components: {},
  props: {
    storeInfo: {
      type: Object,
      default: () => {}
    },
    order_arr: {
      type: Object,
      default: () => {}
    },
    type:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
    };
  },
  computed: {
        activityArr() {
            let order_arr = this.order_arr;
            switch (this.type) {
            case 2:return [
                {cn:'发布订单总数',value:`${order_arr.send_count||0} 个`},
                {cn:'成功订单总额',value:`${this.$options.filters['formatMoney'](order_arr.deal_price_total)} 元`},
                {cn:'预订成功数',value:`${order_arr.deal_count||0} 个`},
                {cn:'实际付款总额',value:`${this.$options.filters['formatMoney'](order_arr.success_order_pay / 100)} 元`},
            ];
            case 3:return [
                {cn:'最近三个月匹配',value:`${order_arr.match_count||0} 次`},
                {cn:'成交订单金额',value:`${this.$options.filters['formatMoney'](order_arr.deal_price_total)} 元`},
                {cn:'报价次数',value:`${order_arr.offer_count	||0} 次`},
                // {cn:'实际收款金额',value:`${this.$options.filters['formatMoney'](this.activityInfo.success_order_pay / 100)} 元`},
                {cn:'成交订单数',value:`${order_arr.deal_count||0} 个`},
            ];
            default:return [];
            }
        }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
  .store{
    width: 100%;
    background-color: #fff;
    text-align: center;
    border-radius: 6px;
    text-align: left;
    margin-top: 20px;
    overflow: hidden;  
    box-shadow: 0px 0px 7px #eee;
 }
 .store-title{
    background-color: #f5f7fc;
    width: 100%;
    padding: 18px;
    color: #2e3949;
    font-size: 16px;
    font-weight: bold;
 }
  .flex-padding{
    padding: 18px;
    align-items: center;
 }
</style>
